module.exports = __webpack_public_path__ + "img/verysatisfied_gray.96a39de1.png";